import { lazy } from "react"
import { lazyRetry } from "./utils"
import { Route } from "react-router-dom"
import { AuthenticatedLayout } from "./wrappers"

const VideoPlayerNew = lazy(() => lazyRetry(() => import("../views/VideoPlayer/VideoPlayerNew"), "videoPlayer"))
const VideoPlayerTabNew = lazy(() => lazyRetry(() => import("../components/VideoPlayer/VideoPlayerTabNew"), "videoPlayerTab"))

const VideoPlayerRoute = (
	<Route
		path="/videos/:videoId"
		element={<AuthenticatedLayout className="video-layout" maximizeContent={true} tab={<VideoPlayerTabNew />} />}
	>
		<Route path="/videos/:videoId" element={<VideoPlayerNew />} />
	</Route>
)

export default VideoPlayerRoute
